(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2381"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2381"] = parcelRequire;
}

var $2a0T1 = parcelRequire("2a0T1");

var $kVp3X = parcelRequire("kVp3X");

var $eYbtH = parcelRequire("eYbtH");

var $cFa6R = parcelRequire("cFa6R");
/*!
 * DrawSVGPlugin 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $10d497c70aa5d6cb$var$gsap, $10d497c70aa5d6cb$var$_toArray, $10d497c70aa5d6cb$var$_doc, $10d497c70aa5d6cb$var$_win, $10d497c70aa5d6cb$var$_isEdge, $10d497c70aa5d6cb$var$_coreInitted, $10d497c70aa5d6cb$var$_warned, $10d497c70aa5d6cb$var$_getStyleSaver, $10d497c70aa5d6cb$var$_reverting, $10d497c70aa5d6cb$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $10d497c70aa5d6cb$var$_getGSAP = function _getGSAP() {
    return $10d497c70aa5d6cb$var$gsap || $10d497c70aa5d6cb$var$_windowExists() && ($10d497c70aa5d6cb$var$gsap = window.gsap) && $10d497c70aa5d6cb$var$gsap.registerPlugin && $10d497c70aa5d6cb$var$gsap;
}, $10d497c70aa5d6cb$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$10d497c70aa5d6cb$var$_types = {
    rect: [
        "width",
        "height"
    ],
    circle: [
        "r",
        "r"
    ],
    ellipse: [
        "rx",
        "ry"
    ],
    line: [
        "x2",
        "y2"
    ]
}, $10d497c70aa5d6cb$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $10d497c70aa5d6cb$var$_parseNum = function _parseNum(value) {
    return parseFloat(value) || 0;
}, $10d497c70aa5d6cb$var$_parseSingleVal = function _parseSingleVal(value, length) {
    var num = $10d497c70aa5d6cb$var$_parseNum(value);
    return ~value.indexOf("%") ? num / 100 * length : num;
}, $10d497c70aa5d6cb$var$_getAttributeAsNumber = function _getAttributeAsNumber(target, attr) {
    return $10d497c70aa5d6cb$var$_parseNum(target.getAttribute(attr));
}, $10d497c70aa5d6cb$var$_sqrt = Math.sqrt, $10d497c70aa5d6cb$var$_getDistance = function _getDistance(x1, y1, x2, y2, scaleX, scaleY) {
    return $10d497c70aa5d6cb$var$_sqrt(Math.pow(($10d497c70aa5d6cb$var$_parseNum(x2) - $10d497c70aa5d6cb$var$_parseNum(x1)) * scaleX, 2) + Math.pow(($10d497c70aa5d6cb$var$_parseNum(y2) - $10d497c70aa5d6cb$var$_parseNum(y1)) * scaleY, 2));
}, $10d497c70aa5d6cb$var$_warn = function _warn(message) {
    return console.warn(message);
}, $10d497c70aa5d6cb$var$_hasNonScalingStroke = function _hasNonScalingStroke(target) {
    return target.getAttribute("vector-effect") === "non-scaling-stroke";
}, $10d497c70aa5d6cb$var$_bonusValidated = 1, //<name>DrawSVGPlugin</name>
//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
$10d497c70aa5d6cb$var$_parse = function _parse(value, length, defaultStart) {
    var i = value.indexOf(" "), s, e;
    if (i < 0) {
        s = defaultStart !== undefined ? defaultStart + "" : value;
        e = value;
    } else {
        s = value.substr(0, i);
        e = value.substr(i + 1);
    }
    s = $10d497c70aa5d6cb$var$_parseSingleVal(s, length);
    e = $10d497c70aa5d6cb$var$_parseSingleVal(e, length);
    return s > e ? [
        e,
        s
    ] : [
        s,
        e
    ];
}, $10d497c70aa5d6cb$var$_getLength = function _getLength(target) {
    target = $10d497c70aa5d6cb$var$_toArray(target)[0];
    if (!target) return 0;
    var type = target.tagName.toLowerCase(), style = target.style, scaleX = 1, scaleY = 1, length, bbox, points, prevPoint, i, rx, ry;
    if ($10d497c70aa5d6cb$var$_hasNonScalingStroke(target)) {
        //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
        scaleY = target.getScreenCTM();
        scaleX = $10d497c70aa5d6cb$var$_sqrt(scaleY.a * scaleY.a + scaleY.b * scaleY.b);
        scaleY = $10d497c70aa5d6cb$var$_sqrt(scaleY.d * scaleY.d + scaleY.c * scaleY.c);
    }
    try {
        //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
        bbox = target.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
    } catch (e) {
        //firefox has a bug that throws an error if the element isn't visible.
        $10d497c70aa5d6cb$var$_warn("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }
    var _ref = bbox || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    if ((!bbox || !width && !height) && $10d497c70aa5d6cb$var$_types[type]) {
        //if the element isn't visible, try to discern width/height using its attributes.
        width = $10d497c70aa5d6cb$var$_getAttributeAsNumber(target, $10d497c70aa5d6cb$var$_types[type][0]);
        height = $10d497c70aa5d6cb$var$_getAttributeAsNumber(target, $10d497c70aa5d6cb$var$_types[type][1]);
        if (type !== "rect" && type !== "line") {
            //double the radius for circles and ellipses
            width *= 2;
            height *= 2;
        }
        if (type === "line") {
            x = $10d497c70aa5d6cb$var$_getAttributeAsNumber(target, "x1");
            y = $10d497c70aa5d6cb$var$_getAttributeAsNumber(target, "y1");
            width = Math.abs(width - x);
            height = Math.abs(height - y);
        }
    }
    if (type === "path") {
        prevPoint = style.strokeDasharray;
        style.strokeDasharray = "none";
        length = target.getTotalLength() || 0;
        $10d497c70aa5d6cb$var$_round(scaleX) !== $10d497c70aa5d6cb$var$_round(scaleY) && !$10d497c70aa5d6cb$var$_warned && ($10d497c70aa5d6cb$var$_warned = 1) && $10d497c70aa5d6cb$var$_warn("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
        length *= (scaleX + scaleY) / 2;
        style.strokeDasharray = prevPoint;
    } else if (type === "rect") length = width * 2 * scaleX + height * 2 * scaleY;
    else if (type === "line") length = $10d497c70aa5d6cb$var$_getDistance(x, y, x + width, y + height, scaleX, scaleY);
    else if (type === "polyline" || type === "polygon") {
        points = target.getAttribute("points").match($10d497c70aa5d6cb$var$_numExp) || [];
        type === "polygon" && points.push(points[0], points[1]);
        length = 0;
        for(i = 2; i < points.length; i += 2)length += $10d497c70aa5d6cb$var$_getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
    } else if (type === "circle" || type === "ellipse") {
        rx = width / 2 * scaleX;
        ry = height / 2 * scaleY;
        length = Math.PI * (3 * (rx + ry) - $10d497c70aa5d6cb$var$_sqrt((3 * rx + ry) * (rx + 3 * ry)));
    }
    return length || 0;
}, $10d497c70aa5d6cb$var$_getPosition = function _getPosition(target, length) {
    target = $10d497c70aa5d6cb$var$_toArray(target)[0];
    if (!target) return [
        0,
        0
    ];
    length || (length = $10d497c70aa5d6cb$var$_getLength(target) + 1);
    var cs = $10d497c70aa5d6cb$var$_win.getComputedStyle(target), dash = cs.strokeDasharray || "", offset = $10d497c70aa5d6cb$var$_parseNum(cs.strokeDashoffset), i = dash.indexOf(",");
    i < 0 && (i = dash.indexOf(" "));
    dash = i < 0 ? length : $10d497c70aa5d6cb$var$_parseNum(dash.substr(0, i));
    dash > length && (dash = length);
    return [
        -offset || 0,
        dash - offset || 0
    ];
}, $10d497c70aa5d6cb$var$_initCore = function _initCore() {
    if ($10d497c70aa5d6cb$var$_windowExists()) {
        $10d497c70aa5d6cb$var$_doc = document;
        $10d497c70aa5d6cb$var$_win = window;
        $10d497c70aa5d6cb$var$_coreInitted = $10d497c70aa5d6cb$var$gsap = $10d497c70aa5d6cb$var$_getGSAP();
        $10d497c70aa5d6cb$var$_toArray = $10d497c70aa5d6cb$var$gsap.utils.toArray;
        $10d497c70aa5d6cb$var$_getStyleSaver = $10d497c70aa5d6cb$var$gsap.core.getStyleSaver;
        $10d497c70aa5d6cb$var$_reverting = $10d497c70aa5d6cb$var$gsap.core.reverting || function() {};
        $10d497c70aa5d6cb$var$_isEdge = (($10d497c70aa5d6cb$var$_win.navigator || {}).userAgent || "").indexOf("Edge") !== -1; //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
    }
};
var $10d497c70aa5d6cb$export$4129f9ba90e1264a = {
    version: "3.12.2",
    name: "drawSVG",
    register: function register(core) {
        $10d497c70aa5d6cb$var$gsap = core;
        $10d497c70aa5d6cb$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        if (!target.getBBox) return false;
        $10d497c70aa5d6cb$var$_coreInitted || $10d497c70aa5d6cb$var$_initCore();
        var length = $10d497c70aa5d6cb$var$_getLength(target), start, end, cs;
        this.styles = $10d497c70aa5d6cb$var$_getStyleSaver && $10d497c70aa5d6cb$var$_getStyleSaver(target, "strokeDashoffset,strokeDasharray,strokeMiterlimit");
        this.tween = tween;
        this._style = target.style;
        this._target = target;
        if (value + "" === "true") value = "0 100%";
        else if (!value) value = "0 0";
        else if ((value + "").indexOf(" ") === -1) value = "0 " + value;
        start = $10d497c70aa5d6cb$var$_getPosition(target, length);
        end = $10d497c70aa5d6cb$var$_parse(value, length, start[0]);
        this._length = $10d497c70aa5d6cb$var$_round(length);
        this._dash = $10d497c70aa5d6cb$var$_round(start[1] - start[0]); //some browsers render artifacts if dash is 0, so we use a very small number in that case.
        this._offset = $10d497c70aa5d6cb$var$_round(-start[0]);
        this._dashPT = this.add(this, "_dash", this._dash, $10d497c70aa5d6cb$var$_round(end[1] - end[0]), 0, 0, 0, 0, 0, 1);
        this._offsetPT = this.add(this, "_offset", this._offset, $10d497c70aa5d6cb$var$_round(-end[0]), 0, 0, 0, 0, 0, 1);
        if ($10d497c70aa5d6cb$var$_isEdge) {
            //to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
            cs = $10d497c70aa5d6cb$var$_win.getComputedStyle(target);
            if (cs.strokeLinecap !== cs.strokeLinejoin) {
                end = $10d497c70aa5d6cb$var$_parseNum(cs.strokeMiterlimit);
                this.add(target.style, "strokeMiterlimit", end, end + 0.01);
            }
        }
        this._live = $10d497c70aa5d6cb$var$_hasNonScalingStroke(target) || ~(value + "").indexOf("live");
        this._nowrap = ~(value + "").indexOf("nowrap");
        this._props.push("drawSVG");
        return $10d497c70aa5d6cb$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$10d497c70aa5d6cb$var$_reverting()) {
            var pt = data._pt, style = data._style, length, lengthRatio, dash, offset;
            if (pt) {
                //when the element has vector-effect="non-scaling-stroke" and the SVG is resized (like on a window resize), it actually changes the length of the stroke! So we must sense that and make the proper adjustments.
                if (data._live) {
                    length = $10d497c70aa5d6cb$var$_getLength(data._target);
                    if (length !== data._length) {
                        lengthRatio = length / data._length;
                        data._length = length;
                        if (data._offsetPT) {
                            data._offsetPT.s *= lengthRatio;
                            data._offsetPT.c *= lengthRatio;
                        }
                        if (data._dashPT) {
                            data._dashPT.s *= lengthRatio;
                            data._dashPT.c *= lengthRatio;
                        } else data._dash *= lengthRatio;
                    }
                }
                while(pt){
                    pt.r(ratio, pt.d);
                    pt = pt._next;
                }
                dash = data._dash || ratio && ratio !== 1 && 0.0001 || 0; // only let it be zero if it's at the start or end of the tween.
                length = data._length - dash + 0.1;
                offset = data._offset;
                dash && offset && dash + Math.abs(offset % data._length) > data._length - 0.2 && (offset += offset < 0 ? 0.1 : -0.1) && (length += 0.1);
                style.strokeDashoffset = dash ? offset : offset + 0.001;
                style.strokeDasharray = length < 0.2 ? "none" : dash ? dash + "px," + (data._nowrap ? 999999 : length) + "px" : "0px, 999999px";
            }
        } else data.styles.revert();
    },
    getLength: $10d497c70aa5d6cb$var$_getLength,
    getPosition: $10d497c70aa5d6cb$var$_getPosition
};
$10d497c70aa5d6cb$var$_getGSAP() && $10d497c70aa5d6cb$var$gsap.registerPlugin($10d497c70aa5d6cb$export$4129f9ba90e1264a);


if (null) null.accept();
(0, $kVp3X.gsap).registerPlugin((0, $eYbtH.ScrollTrigger), (0, $cFa6R.ScrollSmoother), (0, $10d497c70aa5d6cb$export$4129f9ba90e1264a));
function $6c8a262221fb313b$var$init() {
    // initCursor();
    (0, $2a0T1.initNav)();
}
window.addEventListener("load", function() {
    $6c8a262221fb313b$var$init();
});
let $6c8a262221fb313b$var$mm = (0, $kVp3X.gsap).matchMedia();
$6c8a262221fb313b$var$mm.add("(min-width: 768px)", ()=>{
    (0, $cFa6R.ScrollSmoother).create({
        smooth: 1,
        effects: true,
        smoothTouch: 0.1,
        normalizeScroll: true
    });
    // IMPACT & SYMPTONS SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-impact-symptoms--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-impact-symptoms--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $eYbtH.ScrollTrigger).create({
        trigger: "#scrolling-header-impact-symptoms--big",
        animation: scrolling_headers_animation,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // IMPACT INFO DESCRIPTION 1 ANIMATION
    const impact_info_description_1_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    impact_info_description_1_animation.to(".impact__info span", {
        y: "0%",
        stagger: 0.1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".impact__info__title",
        animation: impact_info_description_1_animation,
        start: "top 70%",
        duration: 0.3
    });
    // IMPACT INFO DESCRIPTION 3 ANIMATION
    const impact_info_description_3_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    impact_info_description_3_animation.to(".impact__info__description-3 span", {
        y: "0%",
        stagger: 0.1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".impact__info__description-3",
        animation: impact_info_description_3_animation,
        start: "top 80%"
    });
    // TRANSMISSION & ARRIVAL SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation_disease_war = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-transimission-arrival--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-transimission-arrival--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $eYbtH.ScrollTrigger).create({
        trigger: "#scrolling-header-transimission-arrival--big",
        animation: scrolling_headers_animation_disease_war,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // TRANSMISSION INFO DESCRIPTION 1 ANIMATION
    const transmission__info__description__animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    transmission__info__description__animation.to(".transmission__info span", {
        y: "0%",
        stagger: 0.1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".transmission__info__title",
        animation: transmission__info__description__animation,
        start: "top 70%",
        duration: 0.3
    });
    // CHOLERA REAPER IMAGE ANIMATION
    const cholera_reaper_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    cholera_reaper_animation.to(".cholera-reaper__image", {
        x: window.innerWidth,
        ease: "easeOut"
    }).to(".cholera-reaper__image", {
        scale: 1
    }, 0);
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".cholera-reaper__wrapper",
        animation: cholera_reaper_animation,
        start: "top 50%",
        end: "bottom +=600",
        scrub: 1
    });
    // TRANSMISSION DESCRIPTION 2 ANIMATION
    const transmission__info__description_2__animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    transmission__info__description_2__animation.to(".transmission__wrapper-2 span", {
        y: "0%",
        stagger: 0.1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".transmission__wrapper-2",
        animation: transmission__info__description_2__animation,
        start: "top 90%",
        duration: 0.3
    });
    // EXPOSURE, RACE & SOCIAL POSITION SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation_beriberi = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-exposure--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-exposure--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $eYbtH.ScrollTrigger).create({
        trigger: "#scrolling-header-exposure--big",
        animation: scrolling_headers_animation_beriberi,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // EXPOSURE INFO DESCRIPTION 1 ANIMATION
    const exposure__info__animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    });
    exposure__info__animation.to(".exposure__info span", {
        y: "0%",
        stagger: 0.1,
        duration: 0.3
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".exposure__info__title",
        animation: exposure__info__animation,
        start: "top 70%"
    });
    // EXPOSURE GRAPH ANIMATION
    const exposure_graph_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to(".tableauPlaceholder", {
        opacity: 1,
        duration: 1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".tableauPlaceholder",
        animation: exposure_graph_animation,
        start: "top 70%"
    });
    // EXPERIMENTAL TREATMENTS SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation_experimental_treatments = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-experimental-treatments--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-experimental-treatments--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $eYbtH.ScrollTrigger).create({
        trigger: "#scrolling-header-experimental-treatments--big",
        animation: scrolling_headers_animation_experimental_treatments,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // EXPERIMENTAL TREATMENTS TEXT ANIMATION
    const experimental_treatments_animation = (0, $kVp3X.gsap).timeline({
        paused: "true"
    }).to(".experimental__info span", {
        y: "0%",
        stagger: 0.1
    });
    (0, $eYbtH.ScrollTrigger).create({
        trigger: ".experimental__info__title",
        animation: experimental_treatments_animation,
        start: "top 70%"
    });
});
// Draw Hero Image
const $6c8a262221fb313b$var$hero_tl = (0, $kVp3X.gsap).timeline();
$6c8a262221fb313b$var$hero_tl.from(".hero__image--cholera path", {
    duration: 4,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)",
    fill: "transparent"
}).to(".hero__image", {
    autoAlpha: 1
}, 0).to(".hero__image .cls-1", {
    fill: "#333",
    duration: 4
}, 4).to(".hero__image .cls-2", {
    fill: "#555",
    duration: 4
}, "<");
// Draw Poppy Image
const $6c8a262221fb313b$var$poppy_tl = (0, $kVp3X.gsap).timeline({
    paused: true
});
$6c8a262221fb313b$var$poppy_tl.from("#experimental__image--poppy path", {
    duration: 8,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)",
    fill: "transparent"
});
$6c8a262221fb313b$var$poppy_tl.to(".experimental__image__wrapper-1", {
    opacity: 1
}, 0);
(0, $eYbtH.ScrollTrigger).create({
    trigger: ".section--experimental-treatments",
    animation: $6c8a262221fb313b$var$poppy_tl,
    start: "top 30%"
});
// Draw Lime Image
const $6c8a262221fb313b$var$lime_tl = (0, $kVp3X.gsap).timeline({
    paused: true
});
$6c8a262221fb313b$var$lime_tl.from("#experimental__image--lime path", {
    duration: 5,
    drawSVG: "0%"
});
$6c8a262221fb313b$var$lime_tl.to(".experimental__image__wrapper-2", {
    opacity: 1
}, 0);
(0, $eYbtH.ScrollTrigger).create({
    trigger: ".experimental__image--lime",
    animation: $6c8a262221fb313b$var$lime_tl,
    start: "top 50%"
});
// Draw Theme Lead In
const $6c8a262221fb313b$var$theme_lead_in_animation_tl = (0, $kVp3X.gsap).timeline({
    paused: "true"
});
$6c8a262221fb313b$var$theme_lead_in_animation_tl.from(".theme-lead-in__image path", {
    duration: 4,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)"
});
$6c8a262221fb313b$var$theme_lead_in_animation_tl.to(".theme-lead-in__wrapper", {
    opacity: 1
}, 0);
$6c8a262221fb313b$var$theme_lead_in_animation_tl.to(".theme-lead-in__image .cls-1", {
    fill: "#191919",
    duration: 2
});
$6c8a262221fb313b$var$theme_lead_in_animation_tl.to(".theme-lead-in__arrow-right", {
    width: "100%",
    duration: 0.5
}, "<.5");
$6c8a262221fb313b$var$theme_lead_in_animation_tl.to(".theme-lead-in__next", {
    opacity: 1,
    duration: 1
}, "<+.5");
(0, $eYbtH.ScrollTrigger).create({
    trigger: ".section--theme-lead-in",
    animation: $6c8a262221fb313b$var$theme_lead_in_animation_tl,
    start: "top 20%"
});

})();
//# sourceMappingURL=cholera-epidemic.111bbffd.js.map
